module.exports = __webpack_public_path__ + "static/Procore-cc433e3de22d512cfcafa4cf7d45593c.jpg";